import { render, staticRenderFns } from "./submitOrder.vue?vue&type=template&id=442f6434&scoped=true&"
import script from "./submitOrder.vue?vue&type=script&lang=js&"
export * from "./submitOrder.vue?vue&type=script&lang=js&"
import style0 from "./submitOrder.vue?vue&type=style&index=0&id=442f6434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f6434",
  null
  
)

export default component.exports